module.exports = __webpack_public_path__ + "static/media/addIcon.355194fb.svg";